import type { ViewerPhoto } from '../../ui/PhotoViewer.js';
import { usePhotoViewer } from '../../ui/PhotoViewer.js';
import { PortalPhoto } from './PortalPhoto.js';
import { PortalPhotoViewer } from './PortalPhotoViewer.js';

/** Vignettes de photos (message, complément) : un appui ouvre la visionneuse intégrée. */
export function MessagePhotoGrid({ photos, className, label }: { photos: ViewerPhoto[]; className: string; label?: string }) {
  const viewer = usePhotoViewer();
  if (photos.length === 0) return null;
  return (
    <>
      <ul className={className} {...(label ? { 'aria-label': label } : {})}>
        {photos.map((p, i) => (
          <li key={p.id}>
            <button type="button" onClick={() => viewer.setOpen(i)} className="block w-full" aria-label={`${p.alt} (agrandir)`}>
              <PortalPhoto id={p.id} variant="thumb" alt={p.alt} />
            </button>
          </li>
        ))}
      </ul>
      <PortalPhotoViewer photos={photos} open={viewer.open} onIndexChange={viewer.setOpen} onClose={viewer.close} />
    </>
  );
}
